/* eslint-disable no-nested-ternary */
import {TransitionProps} from './Transition';

export const getTimeouts = ({
  duration,
  delay,
}: Pick<TransitionProps, 'duration' | 'delay'>) => {
  const mountDuration =
    typeof duration === 'number' ? duration : duration.mount;
  const unmountDuration =
    typeof duration === 'number' ? duration : duration.unmount;
  const mountDelay = delay
    ? typeof delay === 'number'
      ? delay
      : delay.mount
    : 0;
  const unmountDelay = delay
    ? typeof delay === 'number'
      ? delay
      : delay.unmount
    : 0;

  return {
    mountDuration: mountDuration || 1,
    unmountDuration: unmountDuration || 1,
    mountDelay,
    unmountDelay,
  };
};
